import { DatePicker, Select } from 'common/InputForm';
import NotFound from 'common/NotFound';
import useDebounce from 'common/UseDebounce';
import useFullPageLoader from 'common/UseFullPageLoader';
import { SearchBar } from 'components/form';
import React, { useEffect, useState } from 'react'
import Pagination from 'react-js-pagination';
import { Link, useSearchParams } from 'react-router-dom';
import { transactionListApi } from 'services/tramsaction';
import { dateFormat } from 'utils/dateFormat';
import findSerialNumber from 'utils/findSerialNumber';

const TransactionList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const [transactionList, setTransactionList] = useState([])
    const activePage = +searchParams.get("page") || 1;
    const search = searchParams.get("search") || ''
    const debouncedValue = useDebounce(search, 300);
    const [input, setInput] = useState({ startDate: '', paymentMode: '' })
    const [total, setTotal] = useState(0)

    //------------Handel-Pagination------------ 
    const handlePageChange = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", event);
        setSearchParams(newParams);
    };
    // ----------handle-search-------------
    const handleSearch = (e) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("search", e.target.value);
        newParams.set("page", 1);
        setSearchParams(newParams);
    }
    // ----------handle-payment-mode-------------
    const handlePaymentMode = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value })
    }
    // ----------handle-date-change-------------
    const handleDateChange = (name, value) => {
        const formatDate = value
        setInput({ ...input, [name]: formatDate })
    }
    // ----------Listing-API-------------------
    useEffect(() => {
        const fetchTransactionList = async () => {
            const query = {
                page: activePage || '',
                search: debouncedValue || '',
                startDate: input.startDate || '',
                paymentMode: input.paymentMode || '',
            };
            onShow();
            try {
                const res = await transactionListApi(query);
                const { code, data } = res?.data;
                if (code === 200) {
                    setTransactionList(data?.data || []);
                    setTotal(data?.total || 0)
                }
            } catch (error) {
                console.log(error);
            } finally {
                onHide();
            }
        };
        fetchTransactionList();
    }, [activePage, debouncedValue, input.startDate, input.paymentMode]);

    useEffect(() => {
        if (!search) {
            searchParams.delete('search')
        }
        if (activePage === 1) {
            searchParams.delete('page')
        }
        setSearchParams(searchParams)
    }, [debouncedValue, activePage])
    return (


        <div className="user-management-container">
            <div className="page_title has_child">
                <h3>Transaction Management</h3>
            </div>
            <div className="card">
                <div className="card">
                    <div className="product-container">
                        {loader}
                        <div className="search-type-input">
                            <div className="search_wrapper">
                                <SearchBar
                                    placeholder="Search..."//by order id
                                    onChange={handleSearch}
                                    value={search}
                                />
                                {/* ------brand options */}
                                <div>
                                    <Select
                                        name='paymentMode'
                                        value={input?.paymentMode}
                                        onChange={handlePaymentMode}
                                    >
                                        <option value="">Payment Mode</option>
                                        <option value="online">Online</option>
                                        <option value="COD">COD</option>

                                    </Select>
                                </div>

                                <div >
                                    <DatePicker
                                        name="startDate"
                                        selected={input?.startDate}
                                        placeholder="Start Date"
                                        isClearable
                                        onChange={(date) => handleDateChange('startDate', date)}
                                    />
                                </div>
                            </div>

                            {/* <Select></Select> */}
                        </div>

                        {/* ------product---card starts */}

                        {/* -------table-list -container */}

                        <div className="table-container">
                            <table className="table custom_table">
                                <thead>
                                    <tr>
                                        <th className="nowrap text-center">S.No</th>
                                        {/* <th className="nowrap text-center">Transaction ID</th> */}
                                        <th className="nowrap text-center">C. ID</th>
                                        <th className="nowrap text-center">Customer Name</th>
                                        <th className="nowrap text-center">Order ID</th>
                                        <th className="nowrap text-center">Amount</th>
                                        <th className="nowrap text-center">Payment Mode</th>
                                        <th className="nowrap text-center">Transaction date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {transactionList && transactionList.length > 0 ? (
                                        transactionList?.map((data, ind) => {
                                            return (
                                                <tr key={ind}>
                                                    <td className="nowrap text-center">
                                                        {findSerialNumber(ind, activePage, 10)}
                                                    </td>
                                                    {/* <td className="nowrap text-center">
                                                        {data?.transactionId || "N/A"}
                                                    </td> */}
                                                    <td className="nowrap text-center">
                                                        {data?.user?.customerId || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.user?.fullName || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.orderId ? `#${data?.orderId}` : "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.total || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {data?.paymentMode || "N/A"}
                                                    </td>
                                                    <td className="nowrap text-center">
                                                        {dateFormat(data?.createdAt) || "N/A"}
                                                    </td>

                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <NotFound
                                            cols={7}
                                            msg={"Transaction data not found"}
                                            onHide={onHide}
                                        />
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* -------------pagination */}
                    {total > 10 && (
                        <div className="pagination-wrapper">
                            <div className="Pagination">
                                <Pagination
                                    activePage={activePage}
                                    previousLabel={"previous"}
                                    nextLabel={"next"}
                                    itemsCountPerPage={10}
                                    totalItemsCount={total}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                    hideDisabled={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
        // <div className="user-management-container">
        //     <div className="page_title has_child">
        //         <h3>Product Management</h3>
        //         <div className="card">
        //             <div className="product-container">
        //                 {loader}
        //                 {/* --------add button */}
        //                 <div className="add-button-container">
        //                     <button
        //                         type="button"
        //                         className="button"
        //                     // onClick={() => {
        //                     //     navigate("/product-management/addNewProduct");
        //                     // }}
        //                     >
        //                         Add Products
        //                     </button>
        //                 </div>
        //                 {/* --------search box */}
        //                 <div className="search-type-input">
        //                     <div className="search_wrapper">
        //                         <SearchBar
        //                             placeholder="Search..."
        //                             onChange={(e) => {
        //                                 const searchIns = new URLSearchParams(searchParams);
        //                                 searchIns.set("search", e.target.value);
        //                                 searchIns.set("page", 1);
        //                                 setSearchParams(searchIns);
        //                             }}
        //                             value={search}
        //                         />
        //                         {/* ------brand options */}
        //                         <div>
        //                             <Select
        //                                 // value={brandOptionFilter}
        //                                 // onChange={(e) => {
        //                                 //     setBrandOptionFilter(e.target.value);
        //                                 //     setFilterBrandState(e.target.value)
        //                                 // }}
        //                                 search={true}
        //                             >
        //                                 {/* <option
        //         value={filterBrandState}
        //         onChange={(e) => {
        //           setFilterBrandState(e.target.value);
        //         }}
        //       >
        //         Select Brand
        //       </option> */}
        //                                 <option value="">Select Brand</option>
        //                                 {/* {brandsList.map((optionProp, ind) => (
        //                         <option value={optionProp._id} key={ind}>
        //                             {optionProp.name}
        //                         </option>
        //                     ))} */}
        //                             </Select>
        //                         </div>

        //                         {/* ------status */}

        //                         <div>
        //                             <Select
        //                                 // value={statusIns}
        //                                 onChange={(e) => {
        //                                     const urlInstance = new URLSearchParams(searchParams);
        //                                     urlInstance.set("status", e.target.value);
        //                                     urlInstance.set("page", 1);
        //                                     setSearchParams(urlInstance);
        //                                 }}
        //                             >
        //                                 <option value="">Select Status</option>
        //                                 {[
        //                                     {value: "APPROVED", name: "Approved" },
        //                                     {value: "PENDING", name: "Pending" },
        //                                     {value: "REJECTED", name: "Rejected" },
        //                                     {value: "RESOLVED", name: "Resolve" },
        //                                 ].map((optionProp, ind) => (
        //                                     <option value={optionProp.value} key={ind}>
        //                                         {optionProp.name}
        //                                     </option>
        //                                 ))}
        //                             </Select>
        //                         </div>
        //                     </div>

        //                     {/* <Select></Select> */}
        //                 </div>

        //                 {/* ------product---card starts */}

        //                 {/* -------table-list -container */}

        //                 <div className="table-container">
        //                     <table className="table custom_table">
        //                         <thead>
        //                             <tr>
        //                                 <th className="nowrap text-center">S.No</th>
        //                                 <th className="nowrap text-center">Image</th>
        //                                 <th className="nowrap text-center">Name</th>
        //                                 <th className="nowrap text-center">Brand</th>
        //                                 <th className="nowrap text-center">Category</th>
        //                                 <th className="nowrap text-center">Sub-Category</th>
        //                                 <th className="nowrap text-center">Action</th>
        //                             </tr>
        //                         </thead>

        //                         <tbody>
        //                             {transactionList && transactionList.length > 0 ? (
        //                                 transactionList?.map((data, ind) => {
        //                                     return (
        //                                         <tr key={ind}>
        //                                             <td className="nowrap text-center">
        //                                                 {findSerialNumber(ind, activePage, 10)}
        //                                             </td>

        //                                         </tr>
        //                                     );
        //                                 })
        //                             ) : (
        //                                 <NotFound
        //                                     cols={7}
        //                                     msg={"Transaction data not found"}
        //                                     onHide={onHide}
        //                                 />
        //                             )}
        //                         </tbody>
        //                     </table>
        //                 </div>
        //             </div>

        //             {/* -------------pagination */}
        //             {total > 10 && (
        //                 <div className="pagination-wrapper">
        //                     <div className="Pagination">
        //                         <Pagination
        //                             activePage={activePage}
        //                             previousLabel={"previous"}
        //                             nextLabel={"next"}
        //                             itemsCountPerPage={10}
        //                             totalItemsCount={total}
        //                             pageRangeDisplayed={5}
        //                             onChange={handlePageChange}
        //                             hideDisabled={true}
        //                         />
        //                     </div>
        //                 </div>
        //             )}
        //         </div>
        //     </div>
        // </div>
    )
}

export default TransactionList